import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            关于51吃瓜网的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <div className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === i ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-600'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5 md:px-6 md:pb-6 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}